
import { Modal, ModalOverlay, ModalContent, ModalBody, ModalCloseButton, Icon } from "@chakra-ui/react"
import { Center, Text, Flex, Button } from "@chakra-ui/react"
import { CheckCircle, ChevronRight } from "../icons/icons"
import { useNavigate } from "react-router-dom"



const PlayWaitlistJoinedModal = ({ isOpen, onClose } : { isOpen: boolean, onClose: () => void }) => { 

    const navigate = useNavigate()

    return <Modal isOpen={isOpen} onClose={onClose} size='md'>
        <ModalOverlay />

        <ModalContent>
            <ModalCloseButton />
                
            <ModalBody p='0 0 20px 0'>
                <Center>
                    <Icon w="50px" h="50px" viewBox="0 0 50 50" color='#06C270' fill='none'>
                        <CheckCircle />
                    </Icon>
                </Center>
                <Center>
                    <Text 
                        variant='title' fontSize='lg' fontWeight='500' mb='20px' mt='10px'
                    >Welcome to the Waitlist!</Text>
                    
                </Center>
                <Center>
                    <Text 
                        textAlign='center'
                        variant='subtle' fontSize='md' fontWeight='400' mb='20px'
                    >
                        You're now on our waitlist. We'll alert you when a spot opens; you'll have 15 minutes to confirm or you'll be moved to the queue's end.
                    </Text>
                </Center>
                <Flex 
                    alignItems='center' justifyContent='space-between' 
                    cursor='pointer' mt='14px'
                    onClick={() => navigate("/user/notifications")}
                >
                    <Text fontSize='md' fontWeight='400' mr='auto'
                        color='#3B4654'
                    >
                        Check notifications
                    </Text>
                    <ChevronRight color='#3B4654' />
                </Flex>

                <Button 
                    mt='20px' mb='10px'
                    variant='light' w='100%'
                    onClick={onClose}

                >Close</Button>
            </ModalBody>
        </ModalContent>
    </Modal>

}

export default PlayWaitlistJoinedModal;